import { usePreviewPanelsContext } from '../preview-panel-context';
import type { Panel } from '../types';

/**
 * @private
 * @deprecated `@atlassian/preview-panels-api` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const useCurrentPreviewPanel = ():
	| (Panel & { setWidth: (width: number) => void; width: number })
	| null => {
	const context = usePreviewPanelsContext();

	if (context?.state.panel == null) {
		return null;
	}

	return {
		...context.state.panel,
		width: context.width,
		setWidth: context.setPanelWidth,
	};
};
